import React from 'react';
import { MenuSymbol } from 'Components/shared/symbols';

const BurgerMenu = ({
  onClick = () => {}
}) => {
  return (
    <div
      onClick={onClick}
      className="rounded cursor-pointer p-24"
    >
      <MenuSymbol size="18px" />
    </div>
  );
};

export default BurgerMenu;
